const TENURE = {

  id: "tenure",
  type: "dropdown",
  props: {
    isMulti: true,
    dropdownProps: {
      label: "Tenure",
      buttonProps: {
        className: "tenure",
      },
      menuProps: {
        style: {
          // minWidth: 300
        }
      }
    },
    options: [
      { label: "Freehold", value: "Freehold" },
      { label: "999 Years", value: "999-Year" },
      { label: "99 Years", value: "99-Year" },
      { label: "60 Years", value: "60-Year" },
      { label: "30 Years", value: "30-Year" },
    ]
  }

}

const COL_TENURE = {

  id: "col_tenure",
  type: "col",
  props: {
    lg: 3,
    md: 4,
    xs: 6,
  },
  children: [TENURE]

}

const COL_MODAL_TENURE = {

  id: "col_tenure",
  type: "col",
  props: {
    lg: 6,
    md: 6,
    xs: 6,
  },
  children: [TENURE]

}

export { TENURE, COL_TENURE, COL_MODAL_TENURE };
